<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="create">新增</el-button>
        <el-button type="primary" style="margin-left: 4px" :disabled="canEdit" @click="canEdit = true">修改</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="save" :disabled="!canEdit" v-if="Status === 0">保存</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="giveUp">放弃</el-button>
      </div>
      <el-form :model="data" :inline="true" :line-form="true" label-width="100px" status-icon v-if="!resetting">
        <el-row class="border">
          <el-form-item label="布产单号">
            <span v-if="Mode == 0 || Status !== 0" class="sapn w193px el-form-item__content" style="min-width: 190px">{{ data.OrderProductNo }}</span>
            <el-input v-else class="w193px" v-model="data.OrderProductNo" placeholder="请输入单据编码" style="min-width: 190px" />
          </el-form-item>
          <el-form-item label="单据日期">
            <el-date-picker
              style="width: 193px"
              v-if="Status === 0 && canEdit"
              v-model="data.ClothDocDate"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="选择单据日期"
              :clearable="false"
              @change="val => previewNo(val)"
            />
            <!-- <span class="not-edit" v-else>{{
              $commonJs.toDateString(data.OrderDate)
            }}</span> -->
            <span class="sapn w193px el-form-item__content" v-else>{{ $commonJs.toDateString(data.ClothDocDate) }}</span>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-select v-if="Status === 0 && canEdit" clearable class="w193px" v-model="data.TradeUnitId" placeholder="请选择客户名称" filterable key="select1" @change="changeTradeUnit">
              <div style="max-height: 274px; overflow: scroll; margin-bottom: -17px; margin-right: -17px">
                <el-option v-for="item in headTradeUnitList" :key="item.TradeUnitId" :value="item.TradeUnitId" :label="item.FullName"></el-option>
              </div>
            </el-select>
            <span class="sapn w193px el-form-item__content" v-else>{{ data.FullName }}</span>
          </el-form-item>
          <el-form-item label="经手人">
            <span class="sapn w193px el-form-item__content">{{ data.ClothMakeEmpName }}</span>
          </el-form-item>
          <el-form-item label="存货编码">
            <span class="sapn w193px el-form-item__content">{{ data.ProductNo }}</span>
          </el-form-item>
          <el-form-item label="存货名称">
            <product-select
              v-if="Status === 0 && canEdit"
              class="w193px"
              v-model="data.ProductName"
              :source="DAccount"
              @select="onSelect"
              :pageSize="pageParams.pageSize"
              :pageIndex="pageParams.pageIndex"
              :listTotal="listTotal"
              @inputText="inputText"
              @click.native="resetFun"
              @currentPage="currentPage"
              isSelect
              @changeSelect="changeSelect"
              :pageType="true"
            />
            <span class="sapn w193px el-form-item__content" v-else>{{ data.ProductName }}</span>
          </el-form-item>
          <el-form-item label="属性">
            <el-select v-if="Status === 0 && canEdit" clearable class="w193px" v-model="data.PropertyId" placeholder="请选择属性" filterable key="select1">
              <el-option v-for="item in propertyList" :key="item.PropertyId" :value="item.PropertyId" :label="item.PropertyName"></el-option>
            </el-select>
            <span class="sapn w193px el-form-item__content" v-else>{{ data.PropertyName }}</span>
          </el-form-item>
          <el-form-item label="颜色">
            <el-select v-if="Status === 0 && canEdit" clearable class="w193px" v-model="data.ColorId" placeholder="请选择颜色" filterable key="select1">
              <el-option v-for="item in Colors" :key="item.ColorId" :value="item.ColorId" :label="item.ColorName"></el-option>
            </el-select>
            <span class="sapn w193px el-form-item__content" v-else>{{ data.ColorName }}</span>
          </el-form-item>
          <el-form-item label="销售单位">
            <span class="sapn w193px el-form-item__content">{{ data.SaUnitName }}</span>
          </el-form-item>
          <el-form-item label="规格型号">
            <span class="sapn w193px el-form-item__content">{{ data.ProductSpec }}</span>
          </el-form-item>
          <el-form-item label="订单数量">
            <span class="sapn w193px el-form-item__content">{{ $commonJs.toThousands(data.SaQuantity) }}</span>
          </el-form-item>
          <el-form-item label="生产单位">
            <span class="sapn w193px el-form-item__content">{{ data.BaseUnitName }}</span>
          </el-form-item>
          <el-form-item label="生产数量">
            <el-input
              class="w193px"
              v-if="Status === 0 && canEdit"
              type="number"
              clearable
              v-model="data.Quantity"
              @blur="changeQuantityEnd"
              @change="changeQuantity"
              placeholder="请输入生产数量"
            ></el-input>
            <span class="sapn w193px el-form-item__content" v-else>{{ $commonJs.toThousands(data.Quantity) }}</span>
          </el-form-item>
          <el-form-item label="批号">
            <div v-if="data.IsBatchNumber">
              <el-input class="w193px" v-if="Status === 0 && canEdit" clearable v-model="data.BatchNumber" placeholder="请输入批号"></el-input>
              <span class="sapn w193px el-form-item__content" v-else>{{ data.BatchNumber }}</span>
            </div>
            <div v-else>暂未开启批号</div>
          </el-form-item>
          <el-form-item label="库存可用量">
            <span class="sapn w193px el-form-item__content">{{ data.StockQuantity }}</span>
          </el-form-item>
          <el-form-item label="BOM版本号">
            <el-select class="w193px" v-if="Status === 0 && canEdit" clearable @change="bomChange" v-model="data.ProductBomNo" placeholder="请选择BOM版本号" filterable key="select2">
              <el-option @click.native="search(item)" v-for="item in teProductList" :key="item.TeProductId" :value="item.Bomno" :label="item.Bomno"></el-option>
            </el-select>
            <span class="sapn w193px el-form-item__content" v-else>{{ data.ProductBomNo }}</span>
          </el-form-item>
          <el-form-item label="生产部门">
            <dp-select style="width: 193px" :disabled="Status === 1 || !canEdit" v-model="data.DpId" />
          </el-form-item>
          <el-form-item label="完工时间">
            <el-date-picker
              style="width: 193px"
              v-if="Status === 0 && canEdit"
              v-model="data.FinishDate"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :clearable="false"
            />
            <span class="sapn w193px el-form-item__content" v-else>{{ $commonJs.toDateString(data.FinishDate) }}</span>
          </el-form-item>
          <el-form-item label="布产日期">
            <el-date-picker
              style="width: 193px"
              v-if="Status === 0 && canEdit"
              v-model="data.ClothDate"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :clearable="false"
            />
            <span class="sapn w193px el-form-item__content" v-else>{{ $commonJs.toDateString(data.ClothDate) }}</span>
          </el-form-item>
          <el-form-item label="备注">
            <el-input class="w193px" v-if="Status === 0 && canEdit" type="text" clearable v-model="data.ClothRemark" placeholder="请输入备注"></el-input>
            <span class="sapn w193px el-form-item__content" v-else>{{ data.ClothRemark }}</span>
          </el-form-item>
          <el-form-item label="查看" v-if="data.TeProductId">
            <el-button type="primary" @click="bomTree">BOM树</el-button>
            <el-button type="primary" @click="bomView">BOM清单</el-button>
          </el-form-item>
        </el-row>
      </el-form>

      <!-- <el-tabs tab-position="top" v-show="buttonType != 'savecloth'">
        <el-tab-pane label="注塑工单">
          <injection-molding
            ref="injection"
            :readonly="readonly"
            :QuickProcess="QuickProcess"
            :injection-mould-boms="InjectionData"
            :sc-quantity="Quantity"
            :edit-rubbers="editRubbers"
            :tradeUnitListProp="tradeUnitList"
            :edit-injection="editInjection"
            :OrderProductNo="data.OrderProductNo"
            :Status="Status"
            :editType="editType"
            @setListEnd="setListEnd"
            :equipmentListProp="equipmentList"
            :warehouseProp="warehouseList"
          ></injection-molding>
        </el-tab-pane>
        <el-tab-pane label="特殊工艺工单">
          <special-process
            ref="special"
            :special-boms="SpecialData"
            :sc-quantity="Quantity"
            :QuickProcess="QuickProcess"
            :editSpecial="editSpecial"
            :tradeUnitListProp="tradeUnitList"
            :propertyListProp="propertyList"
            :OrderProductNo="data.OrderProductNo"
            :editType="editType"
            :Status="Status"
            :equipmentListProp="equipmentList"
            :warehouseProp="warehouseList"
          ></special-process>
        </el-tab-pane>
        <el-tab-pane label="配件工单">
          <parts-order
            ref="parts"
            :parts-boms="PartsData"
            :sc-quantity="Quantity"
            :QuickProcess="QuickProcess"
            :editParts="editParts"
            :propertyListProp="propertyList"
            :tradeUnitListProp="tradeUnitList"
            :OrderProductNo="data.OrderProductNo"
            :editType="editType"
            :Status="Status"
            :equipmentListProp="equipmentList"
            :warehouseProp="warehouseList"
            @changeList="changeListParts"
            @ChangeListParts="changeListPartsList"
          ></parts-order>
        </el-tab-pane>
        <el-tab-pane label="装配工单">
          <assembly-order
            ref="assembly"
            :assembling-boms="AssemblingData"
            :sc-quantity="Quantity"
            :QuickProcess="QuickProcess"
            :edit-assembling="editAssembling"
            :OrderProductNo="data.OrderProductNo"
            :tradeUnitListProp="tradeUnitList"
            :propertyListProp="propertyList"
            :editType="editType"
            :Status="Status"
            @ChangeListArray="ChangeListArray"
            @changeList="changeListAssemly"
            :equipmentListProp="equipmentList"
            :warehouseProp="warehouseList"
          ></assembly-order>
        </el-tab-pane>
        <el-tab-pane label="组合工单">
          <combination-order
            ref="combination"
            :combination-data="CombinationData"
            :sc-quantity="Quantity"
            :QuickProcess="QuickProcess"
            :edit-combination="editCombination"
            :OrderProductNo="data.OrderProductNo"
            :tradeUnitListProp="tradeUnitList"
            :editType="editType"
            :Status="Status"
            @changeList="setList"
            :equipmentListProp="equipmentList"
            :warehouseProp="warehouseList"
          ></combination-order>
        </el-tab-pane>
        <el-tab-pane label="外购件">
          <materials-order
            ref="materials"
            :materials-data="MaterialsData"
            :sc-quantity="Quantity"
            :editType="editType"
            :Status="Status"
          ></materials-order>
        </el-tab-pane>
      </el-tabs> -->
    </div>
  </div>
</template>

<script>
import injectionMolding from '@/components/production/clothmanagement/cloth/workorder/injectionMolding'
import specialProcess from '@/components/production/clothmanagement/cloth/workorder/specialProcess'
import partsOrder from '@/components/production/clothmanagement/cloth/workorder/partsOrder'
import assemblyOrder from '@/components/production/clothmanagement/cloth/workorder/assemblyOrder'
import combinationOrder from '@/components/production/clothmanagement/cloth/workorder/combinationOrder'
import dpSelect from '@/components/production/clothmanagement/cloth/workorder/dpSelect'
import productSelect from '@/components/production/clothmanagement/cloth/select'
import materialsOrder from '@/components/production/clothmanagement/cloth/workorder/materialsOrder'

export default {
  name: 'savecloth',
  components: {
    injectionMolding,
    specialProcess,
    partsOrder,
    assemblyOrder,
    combinationOrder,
    dpSelect,
    productSelect,
    materialsOrder
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      api: require('@/api/production/clothProduction').default,
      workDocApi: require('@/api/production/workDoc').default,
      productApi: require('@/api/ba/product').default,
      mouldApi: require('@/api/ba/mould').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      propertyApi: require('@/api/ba/property').default,
      classApi: require('@/api/ba/class').default,
      dpApi: require('@/api/ent/dp').default,
      teMouldBomApi: require('@/api/production/teMouldBom').default,
      equipmentApi: require('@/api/ba/equipment').default,
      code_api: require('@/api/sy/serialCode').default,
      bomApi: require('@/api/production/teProduct').default,
      productList: [],
      mouldList: [],
      teProductApi: require('@/api/production/teProduct').default,
      teProductList: [],
      optionApi: require('@/api/sy/option').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      pdApi: require('@/api/ba/product').default,
      productionPlanApi: require('@/api/production/productionPlan').default,
      warehouseList: [],
      classList: [],
      initTotal: 0,
      initDAccount: [],
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      data: {
        OrderNo: '',
        OrderProductNo: '',
        OrderDate: this.$commonJs.getToday(),
        FullName: '',
        TradeUnitId: null,
        ColorId: 0,
        SaUnitId: 0,
        DpName: '',
        EmpName: '',
        ProductId: 0,
        OrderId: 0,
        OrderProductId: 0,
        ProductNo: '',
        ProductName: '',
        ProductionDpId: 0,

        ColorName: '',
        ColorId: null,
        SaUnitName: '',
        BatchNumber: '',
        IsBatchNumber: false,
        ProductSpec: '',
        BaseUnitName: '',
        ProductBomNo: '',
        SaQuantity: 0,
        StockQuantity: '',
        Quantity: 1,
        DpId: null,
        DpName: '',

        ClothMakeEmpName: '',
        ClothMakeEmpId: null,
        ClothRemark: '',
        FinishDate: '',
        TeProductId: null,
        ClothDate: this.$commonJs.getToday(),
        ClothDocDate: this.$commonJs.getToday(),
        ProductSpec: ''
      },
      Colors: [],
      Quantity: 1,

      CombinationData: {},
      MaterialsData: [],
      AssemblingData: {},
      PartsData: {},
      SpecialData: {},
      InjectionData: [],
      InjectionRubbers: [],

      TeProductId: 0,

      editRubbers: [],
      initQuantity: 1,

      editInjection: [],
      editCombination: [],
      editAssembling: [],
      editParts: [],
      editSpecial: [],

      clickAssembling: false,
      editType: 0, // 0 未保存，1保存过了
      Status: 0,
      tradeUnitList: [], // 供应商列表
      headTradeUnitList: [], // 表头的客户
      propertyList: [], // 特殊加工列表
      shebeiList: [], // 设备列表
      dpList: [],
      isChange: false,
      isDataQuantityChange: false,
      equipmentList: [],
      QuickProcess: false, // 是否启动快捷方式
      Mode: 0,
      currentClassId: null,
      newGlue: [],
      buttonType: '',

      canEdit: false,
      dataStr: '',
      resetting: false,
      IsProductionAvailable: false //是否考虑可用量
    }
  },
  activated() {
    this.buttonType = this.$route.name
  },
  created() {
    this.buttonType = this.$route.name

    this.equipmentApi.list({ Statuses: [1, 2] }).then(res => {
      if (res.Code === 0) {
        this.equipmentList = res.Data
      }
    })

    this.mouldApi.list({ Statuses: [1, 2] }).then(res => {
      if (res.Code === 0) {
        this.mouldList = res.Data
      }
    })

    this.warehouseApi.list({ WarehouseType: 1 }).then(res => {
      if (res.Code === 0) {
        this.warehouseList = res.Data
      }
    })

    this.tradeUnitApi.list({ TradeUnitTypes: [0, 3], Status: 1 }).then(res => {
      if (res.Code === 0) {
        this.tradeUnitList = res.Data.filter(item => item.TradeUnitType === 3)
        this.headTradeUnitList = res.Data.filter(item => item.TradeUnitType === 0)
      }
    })

    this.propertyApi.list({ Status: 1 }).then(res => {
      if (res.Code === 0) {
        this.propertyList = res.Data
      }
    })

    this.classApi.list({ Status: 1, ClassType: 9 }).then(res => {
      let shebeiList = this.$commonJs.toTreeData(res.Data, 'ClassId')
      localStorage.setItem('shebeiList', JSON.stringify(shebeiList))
    })

    // this.classApi.list({Status: 1, ClassType: 1}).then(res => {
    //   if(res.Code === 0){
    //     this.classList = res.Data
    //   }
    // })

    this.dpApi.list({ Status: 1 }).then(res => {
      console.log('===dpApi===', this.dpList)
      let dpList = this.$commonJs.toTreeData(res.Data, 'DpId')
      localStorage.setItem('dpList', JSON.stringify(dpList))
    })

    this.optionApi.getProductSetting().then(res => {
      if (res.Code === 0) {
        this.QuickProcess = res.Data.QuickProcess
      }
    })

    this.pdApi
      .list({
        Status: 1,
        pageSize: this.pageParams.pageSize,
        pageIndex: this.pageParams.pageIndex
      })
      .then(res => {
        if (res.Code === 0) {
          this.DAccount = res.Data
          this.initDAccount = res.Data
          this.listTotal = res.Count
          this.initTotal = res.Count
        }
      })
  },
  beforeMount() {
    this.dataStr = JSON.stringify(this.data)
  },
  mounted() {
    if (this.$route.params.resData) {
      this.editType = 1
      this.Status = this.$route.params.data.Status
      this.editInit(this.$route.params.resData, this.$route.params.data)
    } else {
      this.editType = 0
      this.canEdit = true
      // this.Status = this.$route.params.data.Status;

      // this.init(this.$route.params.data);
      this.init()
    }
  },
  methods: {
    changeTradeUnit(val) {
      console.log(val)
      var e = this.headTradeUnitList.filter(item => item.TradeUnitId === val)[0]
      this.data.FullName = e.FullName
    },
    onSelect(e) {
      console.log('e=====', e)

      this.data.ProductId = e.ProductId
      this.data.ProductName = e.ProductName
      this.data.ProductNo = e.ProductNo
      this.data.SaUnitId = e.SaUnitId
      this.data.SaUnitName = e.SaUnitName
      this.data.BaseUnitName = e.BaseUnitName
      this.data.StockQuantity = e.StockQuantity
      this.data.ProductSpec = e.ProductSpec
      this.data.IsBatchNumber = e.BatchNumber ?? null
      this.Colors = e.Colors
      this.data.ProductBomNo = ''
      this.teProductApi.list({ Disabled: 0, ProductId: this.data.ProductId }).then(res => {
        if (res.Code === 0) {
          this.teProductList = res.Data
        }
      })
    },
    inputText(text) {
      let o = {}
      if (this.currentClassId) {
        o = {
          pageSize: this.pageParams.pageSize,
          pageIndex: this.pageParams.pageIndex,
          ProductName: text,
          ClassId: this.currentClassId,
          Status: 1
        }
      } else {
        o = {
          pageSize: this.pageParams.pageSize,
          pageIndex: this.pageParams.pageIndex,
          ProductName: text,
          Status: 1
        }
      }
      this.pdApi.list(o).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage({ val, text1 }) {
      this.pageParams.pageIndex = val
      let o = {}
      if (this.currentClassId) {
        o = {
          pageIndex: val,
          pageSize: 7,
          Status: 1,
          ClassId: this.currentClassId,
          ProductName: text1
        }
      } else {
        o = { pageIndex: val, pageSize: 7, Status: 1, ProductName: text1 }
      }
      this.pdApi.list(o).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    changeSelect(val) {
      this.currentClassId = val

      if (val == null) {
        return
      }
      if(val.indexOf(".")){
        var str=val.split(".")
        this.currentClassId=str[str.length-1]
      }

      this.pdApi
        .list({
          ClassId: this.currentClassId,
          Status: 1,
          pageSize: this.pageParams.pageSize,
          pageIndex: this.pageParams.pageIndex
        })
        .then(res => {
          if (res.Code == 0) {
            this.DAccount = res.Data
            this.listTotal = res.Count
          }
        })
    },
    previewNo(val = '') {
      this.code_api.previewNo('布产单', val).then(res => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode
          this.data.OrderProductNo = res.Data.PreviewNo
        } else {
          this.$message.warning('获取布产单编码失败')
        }
      })
    },
    changeQuantityEnd(data) {
      if (!this.isChange) {
      }
    },
    setList(data, dataProductId = 0) {
      this.isChange = true
      this.$refs.assembly.setList(data, dataProductId)
    },
    setListEnd(data, type = 0) {
      this.isChange = true
      console.log(' setListEnd', JSON.parse(JSON.stringify(data)))

      this.setMouldData(data, type)
    },
    changeListPartsList(data) {
      console.log('data', data)
      this.isChange = true
      // 按加工阶段分类
      let special = data.filter(item => {
        return item.UseProcess && item.ProcessStage === 1 && item.PropertyId !== 1 && item.PropertyId !== 0
      })
      let injection = data.filter(item => {
        return item.ProcessStage === 1 && item.PropertyId === 1
      })

      if (special.length !== 0) {
        console.log('触发执行特殊')
        special.forEach(item => {
          this.$refs.special.setList(item)
        })
      }
      if (injection.length !== 0) {
        injection.forEach(item => {
          this.$refs.injection.setList(item)
        })
      }
    },
    ChangeListArray(data) {
      console.log('data', data)
      this.isChange = true
      // 按加工阶段分类
      let parts = data.filter(item => {
        return item.ProcessStage === 2
      })
      let special = data.filter(item => {
        return item.UseProcess && item.ProcessStage === 1 && item.PropertyId !== 1 && item.PropertyId !== 0
      })
      let injection = data.filter(item => {
        return item.ProcessStage === 1 && item.PropertyId === 1
      })

      if (parts.length !== 0) {
        parts.forEach(item => {
          this.$refs.parts.setList(item)
        })
      }
      if (special.length !== 0) {
        console.log('触发执行特殊')
        special.forEach(item => {
          this.$refs.special.setList(item)
        })
      }
      if (injection.length !== 0) {
        injection.forEach(item => {
          this.$refs.injection.setList(item)
        })
      }
    },
    changeListParts(data, dataProductId = 0, lastProcessStage = -1, lastPropertyId = 0) {
      this.isChange = true
      console.log('changeListParts data ChildBomNo', data.ChildBomNo)
      console.log('changeListParts data json', JSON.parse(JSON.stringify(data)))

      if (data.UseProcess && data.ProcessStage === 1 && data.PropertyId !== 1 && data.PropertyId !== 0) {
        this.$refs.special.setList(data)
      } else if (data.ProcessStage === 1 && data.PropertyId === 1) {
        console.log('执行调用')
        this.$refs.injection.setList(data)
      } else if (data.ProcessStage === 0) {
        console.log('changeListAssemly 无', dataProductId, lastProcessStage, lastPropertyId)
        if (lastProcessStage === 1 && lastPropertyId !== 1 && lastPropertyId !== 0) {
          console.log('changeListAssemly 特殊')
          this.$refs.special.setList(data, dataProductId)
        } else if (lastProcessStage === 1 && lastPropertyId === 1) {
          console.log('changeListAssemly 胶件')
          this.$refs.injection.setList(data, dataProductId)
        }
      }
    },
    changeListAssemly(data, dataProductId = 0, lastProcessStage = -1, lastPropertyId = 0) {
      this.isChange = true
      console.log('changeListAssemly data ChildBomNo', data.ChildBomNo)
      console.log('changeListAssemly data json', JSON.parse(JSON.stringify(data)))

      if (data.ProcessStage === 2) {
        this.$refs.parts.setList(data)
      } else if (data.UseProcess && data.ProcessStage === 1 && data.PropertyId !== 1 && data.PropertyId !== 0) {
        this.$refs.special.setList(data)
      } else if (data.ProcessStage === 1 && data.PropertyId === 1) {
        console.log('执行调用')
        this.$refs.injection.setList(data)
      } else if (data.ProcessStage === 0) {
        console.log('changeListAssemly 无', dataProductId, lastProcessStage, lastPropertyId)
        if (lastProcessStage === 2) {
          console.log('changeListAssemly 配件')
          this.$refs.parts.setList(data, dataProductId)
        } else if (lastProcessStage === 1 && lastPropertyId !== 1 && lastPropertyId !== 0) {
          console.log('changeListAssemly 特殊')
          this.$refs.special.setList(data, dataProductId)
        } else if (lastProcessStage === 1 && lastPropertyId === 1) {
          console.log('changeListAssemly 胶件')
          this.$refs.injection.setList(data, dataProductId)
        }
      }
    },
    callBomInfo(ProductId, BomNo, OrderProductNo, Quantity) {
      var loading = this.$loading({
        lock: true,
        text: '正在查询...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })

      this.api
        .bomInfo({ ProductId, BomNo, Qty: Quantity })
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            this.data.ProductBomNo = res.Data.Bomno
            let { Combination, Assembling, Injection, Parts, Special, Materials, TeProductId } = res.Data
            this.TeProductId = TeProductId

            this.CombinationData = []
            this.MaterialsData = Materials || []
            this.AssemblingData = []
            this.SpecialData = []
            this.PartsData = []
            this.InjectionData = []

            this.CombinationData = this.get_data(Combination, OrderProductNo)
            this.AssemblingData = this.get_data(Assembling, OrderProductNo)
            this.SpecialData = this.get_data(Special, OrderProductNo)
            this.PartsData = this.get_data(Parts, OrderProductNo)

            console.log('this.CombinationData', this.CombinationData)
            console.log('this.AssemblingData', this.AssemblingData)
            console.log('this.SpecialData', this.SpecialData)
            console.log('this.PartsData', this.PartsData)
            console.log('this.InjectionData', this.InjectionData)

            Injection.forEach(item => {
              item.OrderProductNo = OrderProductNo
            })

            this.InjectionData = Injection

            let Injection1 = this.sumRubbers(Injection)
            this.setMouldData(Injection1)
          } else {
            this.$message.warning('找不到相关记录, 请先添加bom再操作')
          }
        })
        .catch(err => {
          loading.close()
          console.error(err)
        })
    },
    sumRubbers(data) {
      let arr = []
      let copyData = JSON.parse(JSON.stringify(data))
      copyData.forEach(item => {
        let length = arr.length
        // console.log("length", length);
        let bool = true
        for (let i = 0; i < length; ++i) {
          // console.log("item", item);
          // console.log("arr", arr);
          if (item.ProductId === arr[i].ProductId && item.MouldId === arr[i].MouldId && item.MouldBomNo === arr[i].MouldBomNo) {
            arr[i].Quantity = arr[i].Quantity + item.Quantity
            console.log(`arr[${i}].Quantity`, arr[i].Quantity)
            arr[i].qua = arr[i].qua + item.qua
            console.log(`arr[${i}].qua`, arr[i].qua)
            bool = false
            break
          }
        }
        if (bool) {
          arr.push(item)
          // console.log("arr", arr);
        }
      })

      console.log('sumRubbers arr', arr)

      return arr
    },
    dataFilter(data, stage) {
      return data.filter(item => {
        return item.Stage === stage
      })
    },
    get_data(dataList, OrderProductNo) {
      let arr = []
      let _DetailModels = []
      let _ProcessModels = []

      dataList?.forEach(item => {
        let { DetailModels, ProcessModels, ...rest } = item
        rest.OrderProductNo = OrderProductNo
        arr.push(rest)

        _DetailModels.push({
          Pname: rest.ProductName,
          pid: rest.ProductId,
          fqua: rest.Quantity,
          DetailModels
        })
        _ProcessModels.push({
          Pname: rest.ProductName,
          Pno: rest.ProductNo,
          pid: rest.ProductId,
          ProgrammeId: ProcessModels[0]?.ProgrammeId ?? 0,
          ProgrammeName: ProcessModels[0]?.ProgrammeName ?? '',
          Processes: ProcessModels
        })
      })

      return {
        Bom: arr,
        DetailModels: _DetailModels,
        ProcessModels: _ProcessModels
      }
    },
    setMouldData(Injection, type = 0) {
      this.glueData = JSON.parse(JSON.stringify(Injection))
      console.log('this.glueData', this.glueData)
      if (this.glueData.length !== 0) {
        // 根据模号分类
        // let o = {};
        // this.glueData.forEach((item) => {
        //   console.log("item.MouldId", item.MouldBomNo, item.Pname);
        //   if (o["_" + item.MouldBomNo] == null) {
        //     o["_" + item.MouldBomNo] = [];
        //   }
        //   if (o["_" + item.MouldBomNo]) {
        //     let v = {
        //       ProductId: item.ProductId,
        //       ProductName: item.ProductName,
        //       ColorId: item.ColorId,
        //       ColorName: item.ColorName,
        //       MouldId: item.MouldId,
        //       MouldBomNo: item.MouldBomNo,
        //       Quantity: Number(item.qua) || Number(item.Quantity),
        //     };
        //     o["_" + item.MouldBomNo].push(v);
        //     console.log("o json", JSON.parse(JSON.stringify(o)));
        //   }
        // });
        // console.log("o json", JSON.parse(JSON.stringify(o)));

        // 根据id 获取产出的胶件及其数量
        // let mouldId_arr = Object.keys(o);
        // console.log('mouldId_arr==========', mouldId_arr)

        let mouldId_arr = this.glueData.map(item => item.MouldBomNo)

        mouldId_arr = Array.from(new Set(mouldId_arr))

        let Pres = []
        for (let i = 0; i < mouldId_arr.length; ++i) {
          // console.log('mouldId_arr[i].substr(1)', mouldId_arr[i].substr(1), typeof mouldId_arr[i].substr(1))

          // ssssssssssssssss
          let p = this.teMouldBomApi.bomList({ BomNo: mouldId_arr[i] })
          Pres.push(p)
        }
        if (Pres.length === 0) {
          return
        }

        let glue = []

        Promise.all(Pres).then(res => {
          let length = res.length
          let quas = []
          for (let i = 0; i < length; ++i) {
            if (res[i].Code === 0) {
              console.log(`res[${i}].Data==============`, res[i].Data)
              let { BomRubbers, DetailDtos, ProcessModels, Bomno, ...rest } = res[i].Data[0]
              let dataArr = BomRubbers
              dataArr.forEach(item => {
                if (item.ColorId == null) {
                  item.ColorId = 0
                  item.MouldBomNo = Bomno
                }
              })
              console.log('dataArr==========', dataArr)
              let mouldId = res[i].Data[0]?.MouldId
              let MouldBomNo = Bomno

              // console.log('MouldBomNo====', MouldBomNo)
              // console.log('=============rest====', rest)

              // 在注塑bom胶件中找到需要用到的胶件
              let glueDatas = this.glueData.filter(item => {
                return item.MouldBomNo === MouldBomNo
              })

              // 如果大于1，证明有多个胶件来自同个bom
              if (glueDatas.length > 1) {
                let maxQua = 0
                for (let i = 0; i < glueDatas.length; ++i) {
                  let mouldQuas = dataArr.filter(item => {
                    return item.ProductId === glueDatas[i].ProductId
                  })[0]

                  if (mouldQuas) {
                    let quantity = Number(glueDatas[i].qua) || Number(glueDatas[i].Quantity)
                    let qua = Math.ceil(quantity / mouldQuas.Quantity)

                    if (qua > maxQua) {
                      maxQua = qua
                    }
                  }
                }

                quas.push({
                  ...rest,
                  DetailDtos: DetailDtos,
                  ProcessModels: ProcessModels,
                  MouldId: mouldId,
                  MouldBomNo: MouldBomNo,
                  Quantity: maxQua,
                  mouldQua: rest.Quantity
                })
              }

              if (glueDatas.length === 1) {
                let glueData = glueDatas[0]

                let mouldQuas = dataArr.filter(item => {
                  return item.ProductId === glueData.ProductId
                })[0]

                if (mouldQuas) {
                  let quantity = Number(glueData.qua) || Number(glueData.Quantity)
                  let qua = Math.ceil(quantity / mouldQuas.Quantity)

                  quas.push({
                    ...rest,
                    DetailDtos: DetailDtos,
                    ProcessModels: ProcessModels,
                    MouldId: mouldId,
                    MouldBomNo: MouldBomNo,
                    Quantity: qua,
                    mouldQua: rest.Quantity
                  })
                }
              }

              // let glueDatasMapId = glueDatas.map(item => item.ProductId)

              // let otherGlue = dataArr.filter((item) => {
              //   return glueDatasMapId.indexOf(item.ProductId) === -1
              // })

              // glue.push(...otherGlue)
            }
          }

          // this.newGlue = glue;

          let arr3 = JSON.parse(JSON.stringify(quas))

          // quas.forEach(item => {
          //   let index = ids.indexOf(item.MouldId);

          //   let qua = quas.filter((v) => {
          //     return item.MouldId === v.MouldId && item.ColorId === v.ColorId;
          //   })[0];

          //   if (qua) {
          //     let o = {
          //       MouldBomNo: qua.MouldBomNo,
          //       Quantity: qua.Quantity,
          //       ColorId: qua.ColorId,
          //       ColorName: qua.ColorName,
          //       ...this.mouldList[index],
          //     };
          //     arr3.push(o);
          //   }
          // })

          console.log('arr3 =========== json', arr3)

          this.$refs.injection.setMould(arr3, type)
        })
      } else {
        this.$refs.injection.clearData()
      }
    },

    async editInit(resData, data) {
      let {
        OrderNo,
        OrderProductNo,
        OrderDate,
        FullName,
        TradeUnitId,
        ColorId,
        UnitId2,
        DpName,
        EmpName,
        ProductId,
        OrderId,
        OrderProductId,
        ProductNo,
        ProductName,
        ProductionDpId,
        ColorName,
        UnitName2,
        ProductBomNo,
        SaQuantity,
        scDpName = '',
        StockQuantity = 0,
        ClothMakeEmpName,
        ClothMakeEmpId,
        ClothRemark,
        FinishDate,
        ClothDate,
        ClothDocDate,
        SaUnitName,
        BatchNumber,
        IsBatchNumber,
        ProductSpec,
        BaseUnitName
      } = data
      if (ProductBomNo == null) {
        ProductBomNo = ''
      }
      this.initQuantity = resData.Quantity
      this.teProductApi.list({ Disabled: 0, ProductId }).then(res => {
        if (res.Code === 0) {
          this.teProductList = res.Data
        }
      })

      this.Quantity = resData.Quantity / this.initQuantity
      this.TeProductId = resData.TeProductId

      // 生产数量是否考虑可用量(IsProductionAvailable)true
      const res = await this.productionPlanApi.info()
      this.IsProductionAvailable = res.Data.IsProductionAvailable

      this.data = {
        OrderNo,
        OrderProductNo,
        OrderDate,
        FullName,
        TradeUnitId,
        ColorId,
        UnitId2,
        DpName,
        EmpName,
        ProductId,
        OrderId,
        OrderProductId,
        ProductNo,
        ProductName,
        ProductionDpId,
        ColorName,
        UnitName2,
        ProductBomNo,
        Quantity: this.IsProductionAvailable ? (resData.Quantity - StockQuantity > 0 ? resData.Quantity - StockQuantity : resData.Quantity) : resData.Quantity, // 判断库存数量是否够生产
        SaQuantity,
        DpId: resData.DpId,
        scDpName,
        StockQuantity,
        ClothMakeEmpName,
        ClothMakeEmpId,
        ClothRemark,
        FinishDate,
        ClothDate,
        ClothDocDate,
        SaUnitName,
        BatchNumber,
        IsBatchNumber,
        ProductSpec,
        BaseUnitName
      }

      let { RubberModels, WorkDocModels } = resData

      this.editRubbers = RubberModels

      let combination = this.dataFilter(WorkDocModels, 4)
      let assembly = this.dataFilter(WorkDocModels, 3)
      let parts = this.dataFilter(WorkDocModels, 2)
      let special = this.dataFilter(WorkDocModels, 1)
      let injection = this.dataFilter(WorkDocModels, 0)

      this.editInjection = injection

      this.editCombination = combination
      this.editAssembling = assembly
      this.editParts = parts
      this.editSpecial = special

      // this.setMouldData(RubberModels)

      // this.$nextTick(() => {
      //   this.tabClick({ index: "3" });
      //   this.chuli_data();
      // });
    },
    init() {
      this.previewNo()

      const user = this.$store.state.user
      this.data.ClothMakeEmpName = user.name
      this.data.ClothMakeEmpId = user.empId

      let Quantity = 1

      Quantity = this.isDataQuantityChange ? Quantity : 1
      this.initQuantity = Quantity
      this.Quantity = Quantity / this.initQuantity

      this.Quantity = Quantity
      this.data.Quantity = Quantity
      this.data.SaQuantity = Quantity
    },

    search(data) {
      console.log('data', data)
      this.data.TeProductId = data.TeProductId
      this.TeProductId = data.TeProductId
      let { ProductId, ProductBomNo, OrderProductNo } = this.data
      if (this.buttonType == 'savecloth') return
      this.callBomInfo(ProductId, ProductBomNo, OrderProductNo, this.data.Quantity)
    },
    bomChange(v) {
      if (!v) {
        this.data.TeProductId = 0
      }
    },
    bomView() {
      this.bomApi.getInfoV2(this.data.TeProductId).then(res => {
        if (res.Code === 0) {
          this.$router.push({
            name: 'editbom',
            params: {
              data: res.Data,
              TeProductId: this.data.TeProductId
            }
          })
        }
      })
    },
    bomTree() {
      this.$router.push({
        name: 'treechart',
        params: {
          TeProductId: this.data.TeProductId
        }
      })
    },
    changeQuantity(val) {
      this.isDataQuantityChange = true
      this.data.Quantity = parseFloat(val)
      console.log('************changeQuantity this.initQuantity***********', this.initQuantity)
      //this.Quantity = this.data.Quantity / this.initQuantity;
      let { ProductId, ProductBomNo, OrderProductNo } = this.data
      if (this.buttonType == 'savecloth') return
      this.callBomInfo(ProductId, ProductBomNo, OrderProductNo, this.data.Quantity)
    },
    setSaveData(data) {
      data.forEach(item => {
        item.OrderId = this.data.OrderId
        item.OrderProductId = this.data.OrderProductId
        // item.ProductModels.forEach((v) => {
        //   v.TeProductId = this.TeProductId;
        // });
      })
    },
    // setRutterQua(val) {
    //   this.tabClick({ index: "3" });
    //   this.chuli_data();
    // },
    save() {
      if (this.data.FinishDate === '') {
        this.$message.error('请选择完工时间')
        return
      }

      let WorkDocModels = []
      let combinationData = [] //this.$refs.combination.sendData();
      let assemblyData = []
      let MaterialsData = [] // this.$refs.materials.MaterialsBom;
      let partsData = []
      let specialData = []
      let injectionData = []
      // if (combinationData) {
      //   console.log("组合工单成功获取", combinationData);
      //   assemblyData = []//this.$refs.assembly.sendData();

      //   if (assemblyData) {
      //     console.log("装配工单成功获取", assemblyData);
      //     partsData =[] //this.$refs.parts.sendData();
      //     if (partsData) {
      //       console.log("配件工单成功获取", partsData);
      //       specialData = []//this.$refs.special.sendData();

      //       if (specialData) {
      //         console.log("特殊工艺工单成功获取", specialData);
      //         let { arr, RubberModels } = [];//this.$refs.injection.sendData();
      //         injectionData = arr;

      // if (RubberModels) {
      //   console.log("注塑工单成功获取", RubberModels, injectionData);

      //   this.setSaveData(combinationData);
      //   this.setSaveData(assemblyData);
      //   this.setSaveData(partsData);
      //   this.setSaveData(specialData);
      //   this.setSaveData(injectionData);

      //   RubberModels.forEach((item) => {
      //     item.OrderId = this.data.OrderId;
      //     item.OrderProductId = this.data.OrderProductId;
      //   });

      //   WorkDocModels.push(...combinationData);
      //   WorkDocModels.push(...assemblyData);
      //   WorkDocModels.push(...partsData);
      //   WorkDocModels.push(...specialData);
      //   WorkDocModels.push(...injectionData);
      var str = JSON.stringify(this.data)
      let {
        OrderProductId,
        ProductId,
        DpId,
        StockQuantity,
        Quantity,
        ClothMakeEmpId,
        ClothRemark,
        FinishDate,
        SaQuantity,
        TradeUnitId,
        OrderProductNo,
        ColorId,
        SaUnitId,
        OrderDate,
        ClothDate,
        ClothDocDate,
        BatchNumber,
        ProductSpec
      } = JSON.parse(str)

      SaQuantity = Quantity
      let o = {
        WorkDocModels,
        //RubberModels,
        TeProductId: this.TeProductId,
        OrderProductId,
        ProductId,
        TradeUnitId: TradeUnitId ?? 0,
        MaterialModels: MaterialsData,
        DpId: DpId ?? 0,
        StockQuantity,
        Quantity,
        SaQuantity,
        OrderProductNo,
        ClothMakeEmpId,
        ClothRemark,
        FinishDate,
        ColorId: ColorId ?? 0,
        SaUnitId: SaUnitId ?? 0,
        OrderDate,
        ClothDate,
        ClothDocDate,
        BatchNumber: BatchNumber ?? '',
        ProductSpec: ProductSpec ?? ''
      }
      if (o.ColorId == '') {
        o.ColorId = 0
      }
      console.log('save', o)

      var loading = this.$loading({
        lock: true,
        text: '正在保存...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })

      this.workDocApi
        .add(o)
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            console.log('res.Data', res.Data)
            this.$message({ type: 'success', message: '保存成功' })
            this.data.OrderProductId = res.Data
            this.canEdit = false
            // this.init();
            // this.data= {
            //     OrderNo: "",
            //     OrderProductNo: "",
            //     OrderDate: this.$commonJs.getToday(),
            //     FullName: "",
            //     TradeUnitId: null,
            //     ColorId: 0,
            //     SaUnitId: 0,
            //     DpName: "",
            //     EmpName: "",
            //     ProductId: 0,
            //     OrderId: 0,
            //     OrderProductId: 0,
            //     ProductNo: "",
            //     ProductName: "",
            //     ProductionDpId: 0,

            //     ColorName: "",
            //     ColorId: null,
            //     SaUnitName: "",
            //     BatchNumber: "",
            //     ProductSpec: "",

            //     ProductBomNo: "",
            //     SaQuantity: 0,
            //     StockQuantity: "",
            //     Quantity: 1,
            //     DpId: null,
            //     DpName: "",

            //     ClothMakeEmpName: "",
            //     ClothMakeEmpId: null,
            //     ClothRemark: "",
            //     FinishDate: "",
            //     TeProductId: null,
            //     ClothDate:"",
            //     ClothDocDate:""
            //   }
            //   this.CombinationData = [];
            //   this.MaterialsData = [];
            //   this.AssemblingData = [];
            //   this.SpecialData = [];
            //   this.PartsData = [];
            //   this.InjectionData = [];

            //   loading = this.$loading({
            //     lock: true,
            //     text: "正在更新信息...",
            //     spinner: "el-icon-loading",
            //     customClass: "my_loading",
            //     background: "rgba(0, 0, 0, 0.3)",
            //   });
            //   let orderProductId =  res.Data;
            //   this.data.OrderProductId=orderProductId
            //   this.api
            //     .getInfo(orderProductId)
            //     .then((res) => {
            //       loading.close();
            //       if (res.Code === 0) {
            //         this.editType = 1;
            //         this.canEdit = false;
            //         this.editInit(res.Data, this.data);
            //       }
            //     })
            //     .catch((err) => {
            //       loading.close();
            //     });
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
        .catch(err => {
          this.$message({
            type: 'warning',
            message: '请将表格数据填写完整'
          })
          loading.close()
          console.log(err)
        })
      //         }
      //       }
      //     }
      //   }
      // }
      // let assemblyData = this.$refs.assembly.sendData();
      // let partsData = this.$refs.parts.sendData();
      // let specialData = this.$refs.special.sendData();
      // let { arr, RubberModels } = this.$refs.injection.sendData();
      // let injectionData = arr;

      // combinationData.OrderId = this.data.OrderId;
      // combinationData.OrderProductId = this.data.OrderProductId;
      // combinationData.ProductModels.forEach((v) => {
      //   v.TeProductId = this.TeProductId;
      // });
    },
    // save1() {
    //   if (this.data.FinishDate === "") {
    //     this.$message.error("请选择完工时间");
    //     return;
    //   }

    //   let WorkDocModels = [];
    //   let combinationData = this.$refs.combination.sendData();
    //   let assemblyData = [];
    //   let partsData = [];
    //   let specialData = [];
    //   let injectionData = [];
    //   if (combinationData) {
    //     console.log("组合工单成功获取", combinationData);
    //     assemblyData = this.$refs.assembly.sendData();

    //     if (assemblyData) {
    //       console.log("装配工单成功获取", assemblyData);
    //       partsData = this.$refs.parts.sendData();
    //       if (partsData) {
    //         console.log("配件工单成功获取", partsData);
    //         specialData = this.$refs.special.sendData();

    //         if (specialData) {
    //           console.log("特殊工艺工单成功获取", specialData);
    //           let { arr, RubberModels } = this.$refs.injection.sendData();
    //           injectionData = arr;

    //           if (RubberModels) {
    //             console.log("注塑工单成功获取", RubberModels, injectionData);

    //             this.setSaveData(combinationData);
    //             this.setSaveData(assemblyData);
    //             this.setSaveData(partsData);
    //             this.setSaveData(specialData);
    //             this.setSaveData(injectionData);

    //             RubberModels.forEach((item) => {
    //               item.OrderId = this.data.OrderId;
    //               item.OrderProductId = this.data.OrderProductId;
    //             });

    //             WorkDocModels.push(...combinationData);
    //             WorkDocModels.push(...assemblyData);
    //             WorkDocModels.push(...partsData);
    //             WorkDocModels.push(...specialData);
    //             WorkDocModels.push(...injectionData);

    //             let {
    //               OrderProductId,
    //               ProductId,
    //               DpId,
    //               StockQuantity,
    //               Quantity,
    //               ClothMakeEmpId,
    //               ClothRemark,
    //               FinishDate,
    //               SaQuantity,
    //               TradeUnitId,
    //               OrderProductNo,
    //               ColorId,
    //               SaUnitId,
    //               OrderDate,
    //             } = this.data;

    //             SaQuantity = Quantity;
    //             let o = {
    //               WorkDocModels,
    //               RubberModels,
    //               TeProductId: this.TeProductId,
    //               OrderProductId,
    //               ProductId,
    //               TradeUnitId: TradeUnitId ?? 0,
    //               DpId: DpId ?? 0,
    //               StockQuantity,
    //               Quantity,
    //               SaQuantity,
    //               OrderProductNo,
    //               ClothMakeEmpId,
    //               ClothRemark,
    //               FinishDate,
    //               ColorId: ColorId ?? 0,
    //               SaUnitId: SaUnitId ?? 0,
    //               OrderDate,
    //             };

    //             console.log("save", o);

    //             var loading = this.$loading({
    //               lock: true,
    //               text: "正在保存...",
    //               spinner: "el-icon-loading",
    //               customClass: "my_loading",
    //               background: "rgba(0, 0, 0, 0.3)",
    //             });

    //             this.workDocApi
    //               .add(o)
    //               .then((res) => {
    //                 loading.close();
    //                 if (res.Code === 0) {
    //                   console.log("res.Data", res.Data);
    //                   this.$message({ type: "success", message: "保存成功" });

    //                   loading = this.$loading({
    //                     lock: true,
    //                     text: "正在更新信息...",
    //                     spinner: "el-icon-loading",
    //                     customClass: "my_loading",
    //                     background: "rgba(0, 0, 0, 0.3)",
    //                   });
    //                   let orderProductId =  res.Data;
    //                   this.data.OrderProductId=orderProductId
    //                   this.api
    //                     .getInfo(orderProductId)
    //                     .then((res) => {
    //                       loading.close();
    //                       if (res.Code === 0) {
    //                         this.editType = 1;
    //                         this.editInit(res.Data, this.data);
    //                       }
    //                     })
    //                     .catch((err) => {
    //                       loading.close();
    //                     });
    //                 } else {
    //                   this.$message({ type: "warning", message: res.Msg });
    //                 }
    //               })
    //               .catch((err) => {
    //                 this.$message({
    //                   type: "warning",
    //                   message: "请将表格数据填写完整",
    //                 });
    //                 loading.close();
    //                 console.log(err);
    //               });
    //           }
    //         }
    //       }
    //     }
    //   }
    //   // let assemblyData = this.$refs.assembly.sendData();
    //   // let partsData = this.$refs.parts.sendData();
    //   // let specialData = this.$refs.special.sendData();
    //   // let { arr, RubberModels } = this.$refs.injection.sendData();
    //   // let injectionData = arr;

    // combinationData.OrderId = this.data.OrderId;
    // combinationData.OrderProductId = this.data.OrderProductId;
    // combinationData.ProductModels.forEach((v) => {
    //   v.TeProductId = this.TeProductId;
    // });
    // },
    create() {
      this.$confirm('确认清除数据并新增吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.resetting = true
          this.data = JSON.parse(this.dataStr)
          this.canEdit = true
          this.$nextTick(() => {
            this.resetting = false
            this.init()
          })
        })
        .catch(() => {})
    },
    giveUp() {
      this.$confirm('确认放弃吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.api.getLastId().then(res => {
            if (res.Code == 0) {
              if (res.Data) {
                this.resetting = true
                this.data = res.Data
                this.canEdit = false
                this.$nextTick(() => {
                  this.resetting = false
                  this.teProductApi.list({ Disabled: 0, ProductId: this.data.ProductId }).then(res => {
                    if (res.Code === 0) {
                      this.teProductList = res.Data
                    }
                  })
                })
              } else {
                this.$message.warning('暂无最新记录')
              }
            } else {
              this.$message.error(res.Msg)
            }
          })
          // this.resetting = true;
          // this.data = JSON.parse(this.dataStr);
          // this.canEdit = true;
          // this.api
          // this.$nextTick(() => {
          //   this.resetting = false;
          //   this.init();
          // })
        })
        .catch(() => {})
    }
    // chuli_data() {
    //   // 切换标签时，数据联动
    //   if (this.clickAssembling) {
    //     this.clickAssembling = false;
    //     let assembly_data = this.$refs.assembly.get_data();
    //     let tempData1 = assembly_data.filter((item) => {
    //       return item.ProcessStage === 2;
    //     });
    //     this.$refs.parts.setDetailModels(tempData1);

    //     let tempData2 = assembly_data.filter((item) => {
    //       return item.UseProcess && item.PropertyName !== "注塑";
    //     });

    //     this.$refs.special.setDetailModels(tempData2);

    //     let glueData = assembly_data.filter((item) => {
    //       return item.ProcessStage === 1;
    //     });

    //     console.log("====glueData====", JSON.parse(JSON.stringify(glueData)));

    //     // 根据模号分类
    //     let o = {};
    //     glueData.forEach((item) => {
    //       if (o["_" + item.MouldId] == null) {
    //         o["_" + item.MouldId] = [];
    //       }
    //       if (o["_" + item.MouldId]) {
    //         let v = {
    //           ProductId: item.ProductId,
    //           ProductName: item.Pname,
    //           Quantity: Number(item.qua),
    //         };
    //         o["_" + item.MouldId].push(v);
    //       }
    //     });

    //     console.log("*************o=========", JSON.parse(JSON.stringify(o)));

    //     // 根据id 获取产出的胶件及其数量
    //     let mouldId_arr = Object.keys(o);

    //     console.log("mouldId_arr=========", mouldId_arr);

    //     var loading = this.$loading({
    //       lock: true,
    //       text: "正在加载...",
    //       spinner: "el-icon-loading",
    //       customClass: "my_loading",
    //       background: "rgba(0, 0, 0, 0.3)",
    //     });

    //     let Pres = [];
    //     for (let i = 0; i < mouldId_arr.length; ++i) {
    //       let id = Number(mouldId_arr[i].substr(1));
    //       let p = this.mouldApi.info(id);
    //       Pres.push(p);
    //     }

    //     Promise.all(Pres)
    //       .then((res) => {
    //         loading.close();
    //         let length = res.length;
    //         let quas = [];
    //         for (let i = 0; i < length; ++i) {
    //           let dataArr = res[i].Data.Rubbers;
    //           let mouldId = res[i].Data.MouldId;

    //           // 根据对应id拿到之前保存的需求数量
    //           let productsQuas = o["_" + mouldId];
    //           console.log("productsQuas+++++++++++++", productsQuas);

    //           let productsQuaLength = productsQuas.length;
    //           let maxQua = 0;
    //           for (let j = 0; j < productsQuaLength; ++j) {
    //             let mouldQuas = dataArr.filter((item) => {
    //               return item.ProductId === productsQuas[j].ProductId;
    //             })[0];

    //             console.log("mouldQuas+++++++++++++", mouldQuas);

    //             let qua = Math.ceil(
    //               productsQuas[j].Quantity / mouldQuas.Quantity
    //             );

    //             if (qua > maxQua) {
    //               maxQua = qua;
    //             }
    //           }
    //           quas.push({
    //             MouldId: mouldId,
    //             Quantity: maxQua,
    //           });
    //         }
    //         console.log("quas+++++++++++++", JSON.parse(JSON.stringify(quas)));

    //         let mouldIds = glueData.map((item) => {
    //           return item.MouldId;
    //         });

    //         mouldIds = Array.from(new Set(mouldIds)); // 去除重複的id

    //         let ids = this.mouldList.map((item) => {
    //           return item.MouldId;
    //         });

    //         let mouldData = [];

    //         mouldIds.forEach((item) => {
    //           let index = ids.indexOf(item);
    //           let qua = quas.filter((v) => {
    //             return item === v.MouldId;
    //           })[0];
    //           let o = {
    //             Bomno: "",
    //             Quantity: qua.Quantity,
    //             qua: qua.Quantity,
    //             ...this.mouldList[index],
    //           };
    //           mouldData.push(o);
    //         });

    //         console.log(
    //           "mouldData+++++++++++++",
    //           JSON.parse(JSON.stringify(mouldData))
    //         );

    //         let rubbers = [];
    //         let rubbersNumber = [];

    //         res.forEach((item) => {
    //           rubbers.push(...item.Data.Rubbers);
    //         });

    //         rubbersNumber = rubbers.map((item) => {
    //           return {
    //             ProductId: item.ProductId,
    //             Quantity: item.Quantity,
    //           };
    //         });

    //         glueData.forEach((item) => {
    //           let id = item.ProductId;
    //           // let vQuantity = 0;
    //           rubbersNumber.forEach((v) => {
    //             if (id === v.ProductId) {
    //               item.qua = item.qua;
    //               item.Quantity = item.qua;
    //             }
    //           });

    //           console.log("glueData 后", JSON.parse(JSON.stringify(glueData)));
    //         });

    //         this.$refs.injection.setDetailModels(glueData, mouldData);
    //         this.$refs.assembly.clearData();
    //       })
    //       .catch((err) => {
    //         loading.close();
    //       });
    //   }
    // },
  }
}
</script>

<style lang="scss" scoped>
.el-tabs {
  margin: 18px;
}
.w193px {
  width: 193px;
}
.span {
  display: inline-block;
}
</style>
